<template>
    <form class="boxForm_step4" @submit.prevent="onSubmit">
      <div class="groupInput contact-form">
        <BaseInput
          ref="input"
          @focus="onInputClick(true)"
          @blur="onInputClick(false)"
          :mask="'#'.repeat(11)"
          :placeholder="$t('qic_user_qid_placeholder')"
          :validation="$v.passport_"
          :value="value"
          @input="$emit('input', $event)"
          inputMode="numeric"
          inputStyle="big">
          <template v-if="errors.includes('minLength')" v-slot:invalid-input-error>
            {{ invalidErrorMessage }}
          </template>
        </BaseInput>
      </div>
      <BaseButton/>
      <Reminder v-if="!offReminder"/>
      <BaseIstimara
        :desc="$t('qic_user_qid_explain')"
        :img-en="require('../../assets/images/QID.png')"
        :img-ar="require('../../assets/images/QID.png')"/>
    </form>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import BaseIstimara from '../BaseIstimara.vue'
import Reminder from '../Reminder.vue'
import BaseInput from '../inputs/BaseInput.vue'
import BaseButton from '../buttons/BaseButton.vue'
export default {
  name: 'UserIdForm',
  components: {
    BaseIstimara,
    Reminder,
    BaseInput,
    BaseButton
  },
  emits: [
    'onSubmit'
  ],
  props: {
    value: String,
    offReminder: { type: Boolean, default: false }
  },
  data () {
    return {
      placeholder: ' '
    }
  },
  computed: {
    passport_ () {
      return this.value
    },
    errors () {
      return Object.entries(this.$v.passport_)
        .filter(([key, value]) => !key.startsWith('$') && !value)
        .map(([key, _value]) => key)
    },
    invalidErrorMessage () {
      return this.$t('qic_user_qid_error')
    }
  },
  methods: {
    onSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$v.passport_.$touch()
        const message = this.$refs.input.value
          ? this.invalidErrorMessage
          : this.$refs.input.requireErrorMessage
        this.$emit('error', message)
        return
      }
      this.$emit('onSubmit')
    },
    onInputClick (focused) {
      const children = this.$refs.input.$el.children
      const input = [...children].find(child => child.nodeName === 'INPUT')
      if (focused) input.placeholder = '_'.repeat(11)
      else input.placeholder = ' '
      this.$emit(focused ? 'focus' : 'blur', this.value)
    }
  },
  validations () {
    return {
      passport_: {
        required,
        validFormat: val => /^[23]/.test(val),
        minLength: minLength(11),
        maxLength: maxLength(11)
      }
    }
  }
}
</script>
